/* istanbul ignore file */
import { applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import global from "global";

const middleWares = [thunk];
const appliedMiddleware = applyMiddleware(...middleWares);

const composeEnhancers = global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ name: "Saved Lists" })
  : compose;

const enhancer = composeEnhancers(appliedMiddleware);

export default enhancer;
